import { render, staticRenderFns } from "./yjsDocHistoryList.vue?vue&type=template&id=2a1c3064&scoped=true&lang=true"
import script from "./yjsDocHistoryList.vue?vue&type=script&lang=js"
export * from "./yjsDocHistoryList.vue?vue&type=script&lang=js"
import style0 from "./yjsDocHistoryList.vue?vue&type=style&index=0&id=2a1c3064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1c3064",
  null
  
)

export default component.exports